import { render, staticRenderFns } from "./cloudStorage.vue?vue&type=template&id=50ada9bf&"
import script from "./cloudStorage.vue?vue&type=script&lang=js&"
export * from "./cloudStorage.vue?vue&type=script&lang=js&"
import style0 from "./cloudStorage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "cloudStorage.vue"
export default component.exports